import React, { useState } from "react";
import TeaLogo from "../../assets/tea-logoVersion.svg";
import {
  ChakraProvider,
  Box,
  Center,
  CSSReset,
  Heading,
  Link,
  useToast,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import CustomInput from "../../components/Input";
import Button from "../../components/Button";
import axios from "../../lib/axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../reducers/authReducer";

function Login() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const toast = useToast();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `User/login?correo=${encodeURIComponent(
          email
        )}&password=${encodeURIComponent(password)}`
      );

      if (response.data.success) {
        dispatch(login(response.data.data));

        navigate("/Kids");
        const token = response.data.token;

        localStorage.setItem("accessToken", token);
        toast({
          title: "Successful login",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Login error",
          description: response.data.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Login error",
        description:
          "There was an error trying to log in, please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const linkStyles = {
    color: "#739691",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
    marginTop: "12px",
    marginBottom: "27px",
    display: "block",
    textDecoration: "none",
    textAlign: "left",
  };

  const RegisterLinkStyle = {
    color: "#2B2B21",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  };

  const RegisterYa = {
    color: "#739691",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "normal",
  };

  return (
    <div>
      <ChakraProvider>
        {/* <CSSReset /> */}

        <Center height="100vh" flexDirection="column">
          <Box position="absolute" top="70px">
            <Center>
              <img src={TeaLogo} alt="" />
            </Center>
          </Box>

          <Center flexDirection="column" maxWidth="500px">
            <Box mb="31px">
              <Heading
                as="h2"
                size="xl"
                color="#3C3C3C"
                textAlign="center"
                fontFamily="Inter"
                fontSize="23px"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="40px"
              >
                Log In
              </Heading>
            </Box>

            <Box>
              <CustomInput
                label="Email"
                type="email"
                name="correo"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
              />
            </Box>

            <Box>
              <CustomInput
                label="Password"
                type="password"
                value={password}
                name="password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
              />
              <Box textAlign="left">
                <Link as={RouterLink} style={linkStyles} to="/ForgetPassword">
                  Did you forget your password?
                </Link>
              </Box>
            </Box>

            <Box mb="28px">
              <Button text="Log In" onClick={handleLogin} />
            </Box>

            <Box textAlign="left">
              <Link as={RouterLink} style={RegisterLinkStyle} to="/Register">
                You don't have an account?{" "}
                <span style={RegisterYa}>Register Now!</span>
              </Link>
            </Box>
          </Center>
        </Center>
      </ChakraProvider>
    </div>
  );
}

export default Login;
